/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Background_ColorInputs */

const fr_label_background_color = /** @type {(inputs: Label_Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur de fond`)
};

const en_label_background_color = /** @type {(inputs: Label_Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background color`)
};

/**
* | output |
* | --- |
* | "Background color" |
*
* @param {Label_Background_ColorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_background_color = /** @type {((inputs?: Label_Background_ColorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Background_ColorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_background_color(inputs)
	return en_label_background_color(inputs)
});